var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58878 7.81299L7.15966 14.603C7.20131 15.1256 7.62829 15.5175 8.14994 15.5175H8.15373H18.4835H18.4854C18.9787 15.5175 19.4 15.1502 19.47 14.6626L20.3694 8.45298C20.3902 8.30529 20.3533 8.1576 20.2634 8.03831C20.1744 7.91808 20.0437 7.84044 19.8961 7.81962C19.6982 7.82719 11.4872 7.81583 6.58878 7.81299ZM8.14966 16.9373C6.90282 16.9373 5.84721 15.964 5.74591 14.7191L4.8787 4.40535L3.45198 4.1592C3.06476 4.09103 2.8063 3.72465 2.87258 3.33744C2.94074 2.95022 3.3147 2.69839 3.69339 2.75898L5.6626 3.09981C5.97975 3.15566 6.22117 3.41885 6.24862 3.74074L6.47111 6.39254C19.9867 6.39822 20.0302 6.40485 20.0955 6.41242C20.6229 6.48911 21.0868 6.76461 21.403 7.18874C21.7192 7.61193 21.8517 8.13358 21.776 8.65618L20.8775 14.8649C20.7081 16.0464 19.6818 16.9373 18.4889 16.9373H18.4842H8.15724H8.14966Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9635 11.3122H14.3391C13.9462 11.3122 13.6291 10.9941 13.6291 10.6021C13.6291 10.2102 13.9462 9.89209 14.3391 9.89209H16.9635C17.3554 9.89209 17.6735 10.2102 17.6735 10.6021C17.6735 10.9941 17.3554 11.3122 16.9635 11.3122Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74662 19.5093C8.03159 19.5093 8.26164 19.7393 8.26164 20.0243C8.26164 20.3093 8.03159 20.5403 7.74662 20.5403C7.46071 20.5403 7.23065 20.3093 7.23065 20.0243C7.23065 19.7393 7.46071 19.5093 7.74662 19.5093Z",
    fill: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80_4182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 19,
    width: 2,
    height: 2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22284 20.0238C7.22284 20.3097 7.4529 20.5407 7.73976 20.5407C8.02472 20.5407 8.25478 20.3097 8.25478 20.0238C8.25478 19.7388 8.02472 19.5088 7.73976 19.5088C7.4529 19.5088 7.22284 19.7388 7.22284 20.0238Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80_4182)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.48846 25.2732H12.9868V14.7749H2.48846V25.2732Z",
    fill: "#EBEBEB"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74136 19.8294C7.63438 19.8294 7.54728 19.9165 7.54728 20.0235C7.54728 20.2384 7.93638 20.2384 7.93638 20.0235C7.93638 19.9165 7.84834 19.8294 7.74136 19.8294ZM7.73572 21.2494C7.05976 21.2494 6.51065 20.6994 6.51065 20.0234C6.51065 19.3474 7.05976 18.7983 7.73572 18.7983C8.41169 18.7983 8.96174 19.3474 8.96174 20.0234C8.96174 20.6994 8.41169 21.2494 7.73572 21.2494Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4185 19.5083C18.7035 19.5083 18.9345 19.7384 18.9345 20.0233C18.9345 20.3083 18.7035 20.5393 18.4185 20.5393C18.1326 20.5393 17.9025 20.3083 17.9025 20.0233C17.9025 19.7384 18.1326 19.5083 18.4185 19.5083Z",
    fill: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_80_4182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 19,
    width: 2,
    height: 2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9025 20.0238C17.9025 20.3097 18.1326 20.5407 18.4185 20.5407C18.7025 20.5407 18.9345 20.3097 18.9345 20.0238C18.9345 19.7388 18.7025 19.5088 18.4185 19.5088C18.1326 19.5088 17.9025 19.7388 17.9025 20.0238Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_80_4182)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1682 25.2732H23.6674V14.7749H13.1682V25.2732Z",
    fill: "#EBEBEB"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4296 19.8291C18.3236 19.8291 18.2365 19.9162 18.2365 20.0232C18.2374 20.24 18.6256 20.2381 18.6247 20.0232C18.6247 19.9162 18.5366 19.8291 18.4296 19.8291ZM18.4245 21.2494C17.7485 21.2494 17.1994 20.6994 17.1994 20.0234C17.1994 19.3474 17.7485 18.7983 18.4245 18.7983C19.1014 18.7983 19.6514 19.3474 19.6514 20.0234C19.6514 20.6994 19.1014 21.2494 18.4245 21.2494Z",
    fill: "#EBEBEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.e09a6ee0425c0c6eb909514d125824a7.svg";
export { ForwardRef as ReactComponent };